export function fillHeight() {
  const setFillHeight = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    // --svh is referenced in CSS as calc(var(--svh, 1svh) * 100). Older iOS
    // Safari (< 15.4) does not support the svh unit, so the fallback breaks the
    // calc and collapses heights. Setting it from JS guarantees resolution.
    document.documentElement.style.setProperty('--svh', `${vh}px`);
  }
  let vw = window.innerWidth;
  window.addEventListener('resize', () => {
    if (vw === window.innerWidth) return;
    vw = window.innerWidth;
    setFillHeight();
  });
  // iOS toolbar show/hide changes innerHeight without changing innerWidth, so
  // also refresh on orientation change.
  window.addEventListener('orientationchange', setFillHeight);
  setFillHeight();
};
